import {Component, EventEmitter, Inject, OnInit, Output, PLATFORM_ID} from '@angular/core';
import {BooKingservice} from "../booking.service";

import {Order} from "../order";
import {Ticket} from "../ticket";
import {Pricing} from "../pricing";
import {Paiement} from "../paiement";
import {Router} from "@angular/router";
import {BookingList} from "../../event/bookingList";
import {TranslateService} from "@ngx-translate/core";
import {FonctionUtiles} from "../../fonctionsUtiles";
import {AuthService} from "../../../core/auth/auth.service";
import {isRejected} from "q";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-booking-payment',
  templateUrl: './booking-payment.component.html',
  styleUrls: ['./booking-payment.component.css'],
  providers: [BooKingservice]
})

export class BookingPaymentComponent implements OnInit {

  order: Order;
  tickets: Ticket[] = [];
  bookingLists: BookingList[] = [];
  pricings: Pricing[] = [];
  event: any;
  dayname: string;
  hours: number;
  day: number;
  month: string;
  condition: boolean = false;
  paiement: Paiement;
  onloading: boolean = false;
  error: boolean = false;
  Total: any;
  nbreTicket: number = 0;
  frais: number = 0;
  devise: string;
  days: any;
  daysarray = ' ';
  months = ' ';
  expirationTime: number;
  codePromosActivated: any = [];
  isNormalPayment: boolean = true;
  next_deadlines: any = [];
  I_undertake_to_honor : boolean = false;
  isId3confirrmation:boolean = false;
  order_total: number = 0;

  constructor(private bookingservice: BooKingservice, private router: Router, private translateService: TranslateService, public functionUtils: FonctionUtiles, private authservice: AuthService, @Inject(PLATFORM_ID) private platformId: Object) {
    this.expirationTime = this.bookingservice.retrieve('sessionExpirationTime');
  }

  setDevises(event) {
    if (event.currency) {
      this.devise = event.currency
    }
    else {
      this.devise = 'Eur'
    }
  }

  scrollToTop() {
    this.functionUtils.displayMessages();
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId) && localStorage != undefined) {
      let url_string = window.location.href;
      let url = new URL(url_string);
      if(url.searchParams.get("id3")) {
        this.isId3confirrmation = true;
      }
    }

    setTimeout(() => {
      this.scrollToTop();
      this.event = this.bookingservice.retrieve('event');
      let debut = (this.event.start_date + ' ' + this.event.start_hour);
      let d = new Date(debut.replace(/ /g, "T"));
      this.initTranslation(d);
      this.retriveFormStorageAndInitComponentElements();
      this.dayname = '  ' + this.daysarray[d.getDay()];
      this.hours = d.getHours();
      this.day = d.getDate();
      this.month = this.months[d.getMonth()];
      this.paiement = new Paiement();
      this.setDevises(this.event);
      // this.calculateptionsfee(this.calculateOptionTotal())
      if(!this.isId3confirrmation) {
        console.log('is id3 confirmation');
        this.order.total_price = this.calculRealTotal(this.pricings,this.codePromosActivated) +  this.functionUtils.calculFrais1(this.pricings, this.devise)+this.calculateptionsfee(this.calculateOptionTotal());
        /*this.order.total_price = parseFloat(this.order.total_price) + this.functionUtils.calculFrais(this.pricings, this.devise);*/
        this.order['several_payment'] = false;
        this.order.ca = this.calculRealTotal(this.pricings,this.codePromosActivated);
        this.frais = this.functionUtils.calculFrais1(this.pricings, this.devise) + this.calculateptionsfee(this.calculateOptionTotal());
        this.order.nbParticipant = this.calCulNbreTicket(this.pricings);
        this.order.cAkces = this.frais;
        this.order_total = this.order.total_price;
        //storing element for payment module
        this.bookingservice.store('order',this.order);
        this.bookingservice.store('isNormalPayment',true);
        this.bookingservice.store('I_undertake_to_honor', false);
        this.bookingservice.store('deadlinePayment',false);
      } else {
        this.retriveFormStorageAndInitComponentElements();
      }
    },100);
  }


  retriveFormStorageAndInitComponentElements() {
    this.order = this.bookingservice.retrieve('order');
    this.bookingLists = this.bookingservice.retrieve('bookingList');
    this.pricings = this.bookingservice.retrieve('pricings');
    this.event = this.bookingservice.retrieve('event');
    this.codePromosActivated = this.bookingservice.retrieve('codePromosActivated');
    /*this.isNormalPayment = this.bookingservice.retrieve('isNormalPayment');*/
  }

  initTranslation(d) {
    this.translateService.get('front_booking_payment.daysarray').subscribe(
      value => {
        this.daysarray = value.split(',');
        this.dayname = value.split(',')[d.getDay()];
      }
    );

    this.translateService.get('front_booking_payment.months').subscribe(
      value => {
        this.months = value.split(',');
      });
  }

  codeReduct(code) {
    if (code.reduction_simple)
      return '-' + code.reduction_simple + ' ' + this.functionUtils.getPricingDeviseSymbole(this.devise);
    else if (code.reduction_by_percentage)
      return '-' + code.reduction_by_percentage + ' %';
    else if (code.reduction_type == "Gratuit")
      return 'Gratuit';
  }


  calculTotal(pricings) {
    return this.functionUtils.calculTotal(pricings);
  }

  get_amount_by_maturity(total) {
    return total / parseInt(this.event.number_of_maturity)
  }

  formatDeadlinesList() {
    let date = new Date();
    this.next_deadlines = [];
    for (let i = 1; i <= this.event.number_of_maturity - 1; i++) {
      let deadline = {};
      if(date.getMonth() + i + 1 <=12)
        deadline['date'] =   this.event.reflation_of_payment + '/' + (date.getMonth() + i + 1)+ '/' + date.getFullYear();
      else {
        let k = 1;
        deadline['date'] =   this.event.reflation_of_payment + '/'+k+'/' + (date.getFullYear()+1);
        k++;
      }
      deadline['amount'] = this.calculRealTotal(this.pricings,this.codePromosActivated) / parseInt(this.event.number_of_maturity);
      this.next_deadlines.push(deadline);
    }
  }

  calculatePricingPriceAfterPromoApply(pricing) {
    if (pricing.codePromo && pricing.codePromo.reduction_simple)
      return this.getPricingPrice(pricing) - pricing.codePromo.reduction_simple;
    else if (pricing.codePromo && pricing.codePromo.reduction_by_percentage)
      return this.getPricingPrice(pricing) - (this.getPricingPrice(pricing) * pricing.codePromo.reduction_by_percentage / 100);

  }

  calCulNbreTicket(pricings) {
    let nbreTicket = 0;
    for (let i = 0; i < pricings.length; i++) {
      if (this.getPricingPrice(pricings[i]) && pricings[i].nbreTicket)
      nbreTicket += pricings[i].nbreTicket;
    }
    return nbreTicket;
  }
  calculRealTotal(pricings,codepromos) {
    return parseFloat(this.functionUtils.calculTotal(this.pricings,codepromos));
  }

  calculateOptionTotal() {
    return this.functionUtils.calculateOptionTotal(this.order);
  }

  calculateptionsfee(optionTotal) {
     return this.functionUtils.calculOptionsFee(optionTotal,this.devise);
  }

  displayTotal(total) {
    if (total == 0) {
      return 'Gratuit'
    }
    else {
      return  parseFloat(total).toFixed(2)+' '+this.functionUtils.getPricingDeviseSymbole(this.devise);
    }
  }


  getPricingPrice(pricing) {
    return this.functionUtils.getPricingPrice(pricing);
  }

 /* showPrice(amount) {
    return parseFloat(amount).toFixed(2);
  }*/

  showPrice(price) {
    return price === 0 ?' Gratuit' :' '+ price;
  }
  showCurrency(currency,price) {
    return price === 0 ?' ': currency;
  }


  retour() {
    this.router.navigate(['/booking/infos']);
  }

  clean() {
    this.onloading = false;
    this.error = false;
  }


  valider() {
    this.bookingservice.store('deadlinePayment',false);
    if(!this.isNormalPayment) {
     /* console.log(this.order);*/
      alert('vous devez vous engagez à honorer');
      return false;
    }

    if ((this.paiement.aa == null || this.paiement.ccv == null || this.paiement.mm == null && this.paiement.ncarte) && !this.event.is_free) {
      alert('Veuillez remplir tous les champs pour le paiement et continuer.');
      return;
    }
    //this.order.total_price = this.order.total_price + this.frais;
    this.order.ca = this.calculRealTotal(this.pricings,this.codePromosActivated) ;

    this.order.cAkces = this.functionUtils.calculFrais1(this.pricings, this.devise) + this.calculateptionsfee(this.calculateOptionTotal());
    this.order.nbParticipant = this.nbreTicket;
    this.order['next_deadlines'] = this.next_deadlines;
    this.bookingservice.store('order',this.order);
    this.bookingservice.store('bookingList', this.bookingLists);
    this.bookingservice.store('pricings', this.pricings);
    this.bookingservice.store('event', this.event);
    //this.bookingservice.store('result',this.order);
    if (!this.authservice.loggedIn() && !this.bookingservice.retrieve('inscriptionIframe')) {
      this.authservice.setDestination('/booking/payment');
      this.router.navigate(['login/signin']);
      return;
    }

    //book done check est fait pour empècher de faire empècher une revalidation après qu'arrivé sur le cofirm et la génération de tickets un retour arrière
    // initialisé a notDone depuis eventCompenent et done sur bookingConfirm
    //quand done redirection sur page event
    //not done on continue
    if (this.bookingservice.retrieve('book') != 'done') {
      this.bookingservice.saveOrder(this.order)
        .then(res => {
          this.onloading = false;
          this.error = false;
          // navigate to success
          this.bookingservice.store('result', res);
          this.bookingservice.store('orderSaved', res.order);
          let payment = res.payment;
          let form = document.createElement("form");
          form.method = "POST";
          form.action = payment.endpoint;
          Object.keys(payment.form).forEach(function (key) {
            let element = document.createElement("input");
            element.type = "hidden";
            element.value = payment.form[key];
            element.name = key;
            form.appendChild(element);
          });

          document.body.appendChild(form);
          if (this.order.total_price > 0)
            form.submit();
          else
            this.router.navigate(['/booking/payment/success']);
        })
        .catch(error => {
          this.onloading = false;
          this.error = true;
          console.log(error);
        });
    }
    else {
      this.router.navigate(['/']);
    }
    return;
  }

  normalPayment(e) {
    this.isNormalPayment = true;
    this.order['several_payment'] = false;
    this.next_deadlines = [];  //
    console.log()
    this.order.total_price = this.calculRealTotal(this.pricings,this.codePromosActivated) +  this.functionUtils.calculFrais1(this.pricings, this.devise) + this.calculateptionsfee(this.calculateOptionTotal());
    this.bookingservice.store('isNormalPayment', this.isNormalPayment);
    this.bookingservice.store('order',this.order);
  }

  severalPayment(e) {
    this.formatDeadlinesList();
    this.isNormalPayment = false;
    this.order['several_payment'] = true;//
    this.order.total_price = this.get_amount_by_maturity(this.calculRealTotal(this.pricings,this.codePromosActivated)) +  this.functionUtils.calculFrais1(this.pricings, this.devise) +this.calculateptionsfee(this.calculateOptionTotal());
    this.order['next_deadlines'] = this.next_deadlines;
    this.bookingservice.store('isNormalPayment', this.isNormalPayment);
    this.bookingservice.store('order',this.order);
  }

  under_take_to_honor(e) {
    this.I_undertake_to_honor = true;
  }
  eventGotMultiPayment() {
    return this.event.paymentType != 'normal';
  }

  receivePaymentMessage($event) {
    if($event && $event != 'erreur') {
      this.bookingservice.store('result',$event);
      this.bookingservice.store('orderSaved',$event);
      this.router.navigate(['/booking/payment/success']);
    }
    this.bookingservice.iSId3Confirm = false;
  }

  I_undertake_to_honor_change() {
    this.I_undertake_to_honor = !this.I_undertake_to_honor;
    this.bookingservice.store('I_undertake_to_honor', this.I_undertake_to_honor);
  }
  getPricingBookingTicket(pricingId) {
    let ticketBooking = [];
    for(let i = 0; i < this.bookingLists.length; i++) {
        for(let j = 0 ; j < this.bookingLists[i].tickets.length; j++) {
           if(this.bookingLists[i].tickets[j].pricing_id == pricingId) {
             ticketBooking.push(this.bookingLists[i].tickets[j]);
           }
        }
     }
     return ticketBooking;
  }
}
